/*
 * ReleaseDialogUnsavedResources.tsx  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";
import { isNonEmptyArray } from "@adapptio/lib-shared";
import { IViewInstance } from "../../../../view/ViewService";

export interface IReleaseDialogUnsavedResourcesProps {
	className?: string;
	viewsInstances: IViewInstance[];
}

export const ReleaseDialogUnsavedResources: React.FC<IReleaseDialogUnsavedResourcesProps> = ({
	className,
	viewsInstances
}) => {
	const baseClass = BEM("edt-Release-dialog-unsaved-resources");

	const hasUnsavedViews = isNonEmptyArray(viewsInstances);

	if (className) {
		baseClass.add(className);
	}

	return (
		<div className={baseClass.toClassName()}>
			{hasUnsavedViews ? (
				<>
					<div className={baseClass.element("title").toClassName()}>
						The following tabs are not saved:
					</div>
					<ul className={baseClass.element("list").toClassName()}>
						{viewsInstances?.map((viewInstance) => (
							<li
								key={viewInstance.id}
								className={baseClass.element("list-item").toClassName()}
							>
								{viewInstance.view.getViewInfo().label}
							</li>
						))}
					</ul>
				</>
			) : (
				<div className={baseClass.element("title").toClassName()}>Application is without errors.</div>
			)}
		</div>
	);
};
